var _path, _line, _line2, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowseMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#141140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H23V1H5V8M3 21C3.97778 21 5 20 5 18.7778V8M3 21C2.02222 21 1 20 1 18.7778V8H5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 14.5,
    x2: 19.5,
    y2: 14.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 17.5,
    x2: 19.5,
    y2: 17.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4982 4.50024V9.68252C17.0938 8.80793 16.4578 8.94717 16.1503 9.25175C15.8428 9.55633 16.0286 10.1002 16.4872 10.1002C16.8916 10.1002 17.2735 9.98275 17.4982 9.73908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0006 5.90015V11.0824C12.5962 10.2078 11.9602 10.3471 11.6527 10.6517C11.3452 10.9562 11.531 11.5001 11.9897 11.5001C12.394 11.5001 12.7759 11.3827 13.0006 11.139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 5.90024L17.4981 4.50024"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseMenu);
export default __webpack_public_path__ + "static/media/browse_menu.8f1a6f6c55d73d111f02029f7e4604ab.svg";
export { ForwardRef as ReactComponent };